
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { APP_INITIALIZER, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { AuthService } from '../../shared/src/lib/services/auth/auth.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { jwtInterceptor } from '../../shared/src/lib/utils/interceptors/jwt.interceptor';
import { AppRoutingModule } from './app/app-routing.module';
import { AppLayoutModule } from 'shared';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { PhiPreset } from '../../shared/src/lib/theme/phi-preset';

function appInitializer(authService: AuthService) {
    return () => {
      return new Promise((resolve) => {
        // console.log('App Initializer');
        if (authService.isAuthenticated()) {
          resolve(true);
          // console.log('Authenticated');
        }
        else {
          // console.log('Not Authenticated');
          resolve(false);
          authService.logout();
        }
          
      });
    };
  }



bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(), provideAnimationsAsync(),importProvidersFrom(AppRoutingModule, AppLayoutModule, TranslateModule.forRoot()),
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        // EventService,
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializer,
            multi: true,
            deps: [AuthService],
        },
        ...provideTranslateHttpLoader(),
        provideHttpClient(withInterceptors([jwtInterceptor])),
        providePrimeNG({ theme: { preset: PhiPreset, options: { darkModeSelector: '.app-dark' } } })
    ]
})
    .catch((err) => console.error(err));
